module.exports = __webpack_public_path__ + "img/antes_despues_123.114d8da0.png";